import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-common-functionality',
  templateUrl: './common-functionality.component.html',
  styleUrls: ['./common-functionality.component.scss']
})
export class CommonFunctionalityComponent implements OnInit {

  constructor(public router:Router) { }

  ngOnInit() {
  }

  reloadComponent(self, urlToNavigateTo){
    const url=self ? this.router.url :urlToNavigateTo;
    this.router.navigateByUrl('/',{skipLocationChange:true}).then(()=>{
      this.router.navigate([`/${url}`]).then(()=>{
     //   console.log("navigating on: " + url)
      })
    })
  }

  reloadPage(){
    window.location.reload()
  }

}
